import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import getMapUrl from '../../functions/utils/getMapUrl';
import { COLOR } from '../../styles/colors';
import Text from '../../ui/Text/StyledText';
import Anchor from '../Anchor/Anchor';
import Mascot from '../Image/Mascot';

const StyledFooter = styled.div`
  background: ${props => props.theme.colors.nav.footerDark};
  padding: 40px 20px;
  color: ${COLOR.white};
  text-align: center;
  z-index: 1;
  position: relative;

  & a {
    display: inline-block;
  }
  & address {
    display: inline;
  }

  .photo-or-initial {
    margin: 0 auto 10px;
  }
`;

interface ISchoolFooterProps {
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  mascotUrl: string;
  canonicalUrl: string;
}

const SchoolFooter: React.FC<ISchoolFooterProps> = ({
  name,
  address,
  city,
  state,
  zip,
  mascotUrl,
  canonicalUrl
}) => {
  const theme = useTheme();

  return (
    <StyledFooter>
      <div>
        <Anchor
          href={canonicalUrl}
          className={Font.f16_bold_tall}
          $color={COLOR.white}
        >
          <Mascot
            src={mascotUrl}
            textColor={theme?.colors.school.primary}
            backgroundColor={COLOR.white}
            name={name}
            size={56}
          />
          {name}
        </Anchor>
      </div>
      <a
        target="_blank"
        rel="nofollow noreferrer noopener"
        href={getMapUrl(address, city, state, zip)}
      >
        <Text
          as="address"
          className={Font.f14_tall}
          $color="rgba(255,255,255,.5)"
        >
          {address}
          <br />
          <span>
            {city}, {state} {zip}
          </span>
        </Text>
      </a>
    </StyledFooter>
  );
};

export default SchoolFooter;
